import { Spacer } from '@chakra-ui/react';
import { EventDetail } from 'model/modules/events/eventDetail';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import EventDetailDescription from './sections/EventDetailDescription';
import EventDetailDirections from './sections/EventDetailDirections';
import EventDetailPhotos from './sections/EventDetailPhotos';
import EventDetailPreview from './sections/EventDetailPreview';
import EventDetailTopics from './sections/EventDetailTopics';
import EventDetailVideo from './sections/EventDetailVideo';
import EventDetailVideoReviews from './sections/EventDetailVideoReviews';

interface Props {
  data: EventDetail;
}

const EventDetailLoaded: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <EventDetailPreview
        preview={data.preview}
        title={data.name}
        subtitle={data.subtitle}
      />
      <Spacer h="20px" />
      {data.videoUrl && (
        <>
          <EventDetailVideo videoUrl={data.videoUrl} />
          <Spacer h="20px" />
        </>
      )}
      {data.photos.length > 0 && (
        <>
          <EventDetailPhotos photos={data.photos} chunkPhotosLength={data.photoLimit ?? 12}/>
          <Spacer h="20px"/>
        </>
      )}
      {data.category.topics.length > 0 && (
        <>
          <EventDetailTopics topics={data.category.topics} />
          <Spacer h="20px" />
        </>
      )}
      {data.category.directions.length > 0 && (
        <>
          <EventDetailDirections directions={data.category.directions} />
          <Spacer h="20px" />
        </>
      )}
      <EventDetailDescription
        description={data.description}
        presentationUrl={data.presentation}
        title={data.descriptionTitle}
      />
      <Spacer h="20px" />
      {data.category.feedbacks.length > 0 && (
        <>
          <EventDetailVideoReviews videoReviews={data.category.feedbacks} />
        </>
      )}
      {data.category.nextEvents.length > 0 && (
        <>
          <EventGridCarousel
            events={data.category.nextEvents}
            title={t('nextEvents')}
          />
          <Spacer h="20px" />
        </>
      )}
      {data.category.prevEvents.length > 0 && (
        <>
          <EventGridCarousel
            events={data.category.prevEvents}
            title={t('prevEvents')}
          />
          <Spacer h="20px" />
        </>
      )}
    </>
  );
};

export default EventDetailLoaded;
